import React, { useEffect } from 'react';
import SEO from './SEO';
import './TermsAndConditions.css';

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO page="terms" />
      <div className="terms-page">
        <div className="terms-container">
          <h1 className="terms-title">Terms &amp; Conditions</h1>
          <div className="terms-intro">
            <p>Effective August 30, 2026. These Terms govern your use of the TapTrap mobile application. By using the App, you agree to them.</p>
          </div>

          <div className="terms-content">
            <section className="terms-section">
              <h2>1. Account-Free Service</h2>
              <p>TapTrap is a multi-touch party game. The current App does not require or offer account registration. Access, onboarding, settings, and custom categories are tied to the local installation rather than a TapTrap account.</p>
            </section>

            <section className="terms-section">
              <h2>2. Purchases and Subscriptions</h2>
              <p>Premium purchases are processed by Apple App Store or Google Play and managed through RevenueCat using an anonymous installation identity. Prices, billing periods, trial terms, renewal terms, and cancellation options are shown during purchase.</p>
              <p>If you reinstall, you may need to use Restore Purchases with the same store account. TapTrap does not promise cross-platform subscription portability between iOS and Android. Store refund and billing rules also apply.</p>
            </section>

            <section className="terms-section">
              <h2>3. Custom Categories and Local Storage</h2>
              <p>Custom categories are encrypted and saved only on the device where you create them. TapTrap does not upload, synchronize, or back them up. You are responsible for maintaining access to the device, and deleting the App or clearing storage may permanently remove that content.</p>
              <p>If Premium expires, locally saved categories remain stored but their creation or use may be blocked until Premium access is restored.</p>
            </section>

            <section className="terms-section">
              <h2>4. Historical Account Data</h2>
              <p>Accounts created through older TapTrap versions are no longer used by the current App. Historical account and cloud-content records may remain available only for support, legal obligations, and verified deletion. Instructions are available at <a href="https://taptrap.app/delete" className="contact-link">taptrap.app/delete</a>.</p>
            </section>

            <section className="terms-section">
              <h2>5. User Content and Conduct</h2>
              <p>You are responsible for custom content created on your device and for how participants use the App. Do not create or encourage hateful, harassing, unlawful, exploitative, self-harm, non-consensual, or dangerous content. Respect every participant's decision not to answer or perform a dare.</p>
            </section>

            <section className="terms-section">
              <h2>6. Third-Party Services</h2>
              <p>The App relies on Apple or Google for purchases, RevenueCat for subscription entitlements, Sentry for diagnostics, Microsoft Clarity for product analytics, and hosting providers for public game content. Your use of those services may also be governed by their terms and privacy policies.</p>
            </section>

            <section className="terms-section">
              <h2>7. Availability and Changes</h2>
              <p>We may modify content, features, Premium offerings, or technical requirements. RevenueCat placements may remotely select different paywall presentations. A remotely configured paywall may or may not provide a close control, while purchases and restores remain subject to store behavior.</p>
            </section>

            <section className="terms-section">
              <h2>8. Disclaimer and Limitation of Liability</h2>
              <p>TapTrap is provided "as is" and "as available." To the maximum extent permitted by law, we disclaim implied warranties and are not liable for indirect, incidental, special, consequential, or punitive damages, lost local content, unavailable subscriptions, or interruptions. Nothing here excludes rights that cannot legally be excluded.</p>
            </section>

            <section className="terms-section">
              <h2>9. Governing Law</h2>
              <p>These Terms are governed by the laws of the Dominican Republic, without limiting mandatory consumer protections that apply where you live. We encourage contacting us first to resolve concerns informally.</p>
            </section>

            <section className="terms-section">
              <h2>10. Intellectual Property</h2>
              <p>TapTrap, its branding, software, artwork, and provided game content are protected by applicable intellectual property laws. These Terms do not transfer ownership to you.</p>
            </section>

            <section className="terms-section">
              <h2>11. Contact Information</h2>
              <p>Questions may be sent to <a href="mailto:hi@taptrap.app" className="contact-link">hi@taptrap.app</a>.</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default TermsAndConditions;
